import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateZoneDocument } from './update.generated';

export const useUpdateZone = (options: ApiOptions<typeof UpdateZoneDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UpdateZoneDocument, {
    ...useNotifications(UpdateZoneDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.zones.update_success'),
    }),

    ...options,
  });
};
